var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-log',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function({ message }){return [_c('span',{staticClass:"dark-purple--text text-decoration-underline font-weight-bold font-italic"},[_vm._v(" "+_vm._s(message.toUpperCase())+" ")])]}}])},'default-log',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }